module.exports = __webpack_public_path__ + "static/media/gog.0851aba4.svg";